import { styled } from '@mui/material';
import React, { useEffect, useState } from 'react';

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

const Segment = styled('div')(() => ({
  flexBasis: 0,
  flexGrow: 1,
  position: 'relative',
  width: '10%',
  height: 2,
  marginLeft: '4px',
}));

interface PasswordStrengthProps {
  length?: number;
  onChange?: (data: string) => void;
  setIsValidPwd?: React.Dispatch<React.SetStateAction<boolean>>;
  value: string;
}

interface ColorMap {
  [key: number]: string;
}
const score_colors: ColorMap = {
  0: '#ddd',
  1: '#ef4836',
  2: '#f6b44d',
  3: '#2b90ef',
  4: '#25c281',
};

const PasswordStrength = ({
  length = 6,
  value,
  setIsValidPwd,
}: // onChange = () => null,
PasswordStrengthProps) => {
  const [barColor, setBarColor] = useState<string>('#ddd');
  const [barColoredCount, setBarColoredCount] = useState<number>(0);

  useEffect(() => {
    const pwlength = value.length >= 6 ? 1 : 0;
    const lowercase = /[a-z]/.test(value) ? 1 : 0;
    const uppercase = /[A-Z]/.test(value) ? 1 : 0;
    const numbers = /[0-9]/.test(value) ? 1 : 0;
    const score = pwlength + lowercase + uppercase + numbers;
    if (setIsValidPwd) setIsValidPwd(score === 4);
    setBarColor(score_colors[score] ?? '');
    setBarColoredCount(Math.round((score * length) / 4));
  }, [value]);

  return (
    <Container>
      {Array.from(Array(length).keys()).map((el: number) => (
        <Segment
          key={el}
          style={{
            backgroundColor: el <= barColoredCount - 1 ? barColor : score_colors[0],
          }}
        />
      ))}
    </Container>
  );
};

export default PasswordStrength;
